<template>
  <div
    class="sb-actions-menu"
    :class="activeClasses"
    data-testid="sb-data-table-actions-menu"
  >
    <span
      class="sb-actions-menu__rows-selected"
      data-testid="sb-data-table-action__selected-items"
      >{{ labelselectedItemsLength }}</span
    >
    <SbButton
      size="medium"
      :label="cancelButtonLabel"
      class="sb-actions-menu__btn-cancel"
      data-testid="sb-data-table-action__clear"
      appearance="clear"
      variant="secondary"
      @click="$emit('cancel')"
    />
    <component
      :is="isOnDesktop ? 'SbButton' : 'SbIconButton'"
      v-for="action in actions"
      :key="action.value"
      v-tooltip="disabledTooltip(action)"
      :label="action.label"
      appearance="clear"
      variant="secondary"
      is-clear
      size="small"
      :icon="action.icon"
      :is-disabled="action.disabled"
      :is-loading="action.isLoading"
      :data-testid="`sb-data-table-action__${action.value}`"
      @click="() => $emit('click', action.value)"
    />
  </div>
</template>

<script lang="ts">
import SbButton from '../../Button'
import SbIconButton from '../../IconButton'
import { Tooltip } from '../../../directives'
import i18n, { type Locale } from '../../../i18n'
import type { PropType } from 'vue'
import { useWindowResizeObserver } from '../../../mixins'
import type { DataTableAction, DataTableItem } from '../types'

export default {
  name: 'SbDataTableActions',

  components: {
    SbButton,
    SbIconButton,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    actions: {
      type: Array as PropType<DataTableAction[]>,
      default: () => [],
    },
    hideLabelActionsBreakpoint: {
      type: Number,
      default: null,
    },
    selectedRows: {
      type: Array as PropType<DataTableItem[]>,
      default: () => [],
    },
    sticky: {
      required: false,
      type: Boolean,
      default: false,
    },
    locale: {
      type: String as PropType<Locale>,
      default: 'en',
    },
  },

  emits: ['cancel', 'click'],

  setup() {
    const { isOnDesktop } = useWindowResizeObserver()
    return {
      isOnDesktop,
    }
  },

  computed: {
    activeClasses() {
      return {
        'sb-actions-menu--sticky': this.sticky,
      }
    },
    labelselectedItemsLength() {
      const labelItem = this.selectedItemsLength > 1 ? 'items' : 'item'
      return `${this.selectedItemsLength} ${labelItem} selected`
    },
    selectedItemsLength() {
      return this.selectedRows.length
    },
    cancelButtonLabel() {
      return i18n(this.locale, 'Cancel')
    },
  },

  methods: {
    disabledTooltip(action: DataTableAction) {
      const isDisabled = action.disabled
      return {
        label: isDisabled ? action.disabledText : action.label,
        variant: isDisabled ? 'light' : 'dark',
        position: 'bottom',
        show: isDisabled || !this.isOnDesktop,
      }
    },
  },
}
</script>
